module.exports = __webpack_public_path__ + "static/img/notice.32e30480.png";